

















































import '../styles/document-tile.css'
import { CIcon } from '@coreui/icons-vue'
import {
  cilFile,
  cisStar,
  cilStar,
  cilTrash,
  cilPencil,
} from '@coreui/icons-pro'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      usePlaceholder: false,
      fileIcon: cilFile,
      favoritedStarIcon: cisStar,
      standardStarIcon: cilStar,
      deleteIcon: cilTrash,
      editIcon: cilPencil,
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    createdDate: {
      type: Date,
      required: true,
    },
    favorite: {
      type: Object,
      required: false,
    },
    isAdministrator: {
      type: Boolean,
      required: true,
    },
    searchPath: {
      type: String,
      required: false,
    },
  },
  name: 'DocumentTile',
  components: { CIcon },
  mounted: async function () {
    try {
      const canLoadImage = await fetch(this.imageUrl)

      if (!canLoadImage.ok) this.usePlaceholder = true
    } catch {
      this.usePlaceholder = true
    }
  },
  methods: {
    onViewClick(e: Event) {
      e.preventDefault()
      this.$emit('view-click', this.id)
    },
    onFavoriteClick() {
      this.$emit('toggle-favorite', {
        favoriteId: this.favorite?.id,
        id: this.id,
      })
    },
    onDeleteClick() {
      this.$emit('delete-resource', this.id)
    },
    onEditClick() {
      this.$emit('edit-resource', this.id)
    },
  },
})
